import { render, staticRenderFns } from "./ClosedTickets.vue?vue&type=template&id=b091e1ba&"
import script from "./ClosedTickets.vue?vue&type=script&lang=js&"
export * from "./ClosedTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports